import { render, staticRenderFns } from "./extraEnrol.vue?vue&type=template&id=654528e8&scoped=true&"
import script from "./extraEnrol.vue?vue&type=script&lang=js&"
export * from "./extraEnrol.vue?vue&type=script&lang=js&"
import style0 from "./extraEnrol.vue?vue&type=style&index=0&id=654528e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654528e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VSelect,VTextField})
